













































import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { IDrawableItemEditable } from "../../IDrawableItemEditable";
import { DomainRegistry } from "../../../../../domain";
import { IOcojoImageSource } from "../../../../../domain/ocojo";
import { Patient } from "../../../../../domain/patient";
import { Department } from "../../../../../domain/department";
import {
  ClaioImageSizeSelector,
  ClaioImagePreviewSizeSelector,
  ClaioImagePreview,
} from "./claio";
import {
  OcojoImageFinder,
  OcojoImageThumbnail,
} from "./ocojo";
import { Size } from "../../../../../domain/drawing";

@Component({
  components: {
    OcojoImageThumbnail,
    OcojoImageFinder,
    ClaioImageSizeSelector,
    ClaioImagePreviewSizeSelector,
    ClaioImagePreview,
  }
})
export default class OcojoContentsTool extends Mixins() {
  data(): any {
    return {
      currentPage: 1,
      foundOcojoImages: [] as IOcojoImageSource[],
      displayOcojoImages: [] as IOcojoImageSource[],
      isOcojoImageFinding: false,
      isFitted: true,
      thumbnailSize: ClaioImageSizeSelector.Option.small,
      selectedItemIndex: null,
      selectedOcojoImageSource: null as IOcojoImageSource,
      enableLayer: true,
    };
  }
  currentPage: number;
  foundOcojoImages: IOcojoImageSource[];
  displayOcojoImages: IOcojoImageSource[];
  isOcojoImageFinding: boolean;
  isFitted: boolean;
  thumbnailSize: Size;
  selectedOcojoImageSource: IOcojoImageSource;
  enableLayer: boolean;
  selectedItemIndex: number;

  @Prop()
  source: IDrawableItemEditable;

  @Prop()
  patient: Patient;

  @Prop()
  department: Department;

  @Prop({ default: true })
  isPastable: boolean;

  get imageCountPerPage(): number {
    return this.$configuration.behavior.document.editor.contents.ocojo.displayCountPerPage;
  }

  thumbnailSelected(src: IOcojoImageSource, index: number): void {
    this.selectedOcojoImageSource = src;
    this.selectedItemIndex = index;
  }

  launchOcojo(src: IOcojoImageSource): void {
    const service = DomainRegistry.localhost.getApplicationService();
    const departmentId = !!src.departmentId ? src.departmentId : this.department.id;
    service.launchOcojo(this.$store.getters.user, this.patient, departmentId, src.claioImageKey, src.isMovie)
    .then(() => {
      // DO NOTHING
    })
    .catch(e => {
      this.$error("汎用画像ビューア起動失敗", "汎用画像ビューアの起動処理中にエラーが発生しました。", e);
    });
  }

  resetScrollPosition(): void {
    // ページ遷移が起こった時にスクロールを初期位置に戻す
    const container = this.$refs.container as HTMLDivElement;
    if (!container) { return; }
    container.scrollTop = 0;
    container.scrollLeft = 0;
  }

  @Watch("enableLayer")
  onEnableLayerUpdated(newValue: boolean, oldValue: boolean): void {
    this.setLayerVisibility(newValue);
  }

  setLayerVisibility(value: boolean): void {
    if (!this.foundOcojoImages) { return; }
    for (let index = 0; index < this.foundOcojoImages.length; ++index) {
      if (this.foundOcojoImages[index].isVisibleLayer === value) { continue; }
      const cloned = this.foundOcojoImages[index].clone();
      cloned.isVisibleLayer = value;
      this.foundOcojoImages.splice(index, 1, cloned);
    }
  }

  @Watch("foundOcojoImages")
  onFoundOcojoImagesUpdated(): void {
    for (const image of this.foundOcojoImages) {
      image.isVisibleLayer = this.enableLayer;
    }
    this.updateDisplayOcojoImages();

    if (this.selectedOcojoImageSource) {
      const found = this.foundOcojoImages.find(i => i.claioImageKey === this.selectedOcojoImageSource.claioImageKey);
      this.selectedOcojoImageSource = !!found ? found : null;
    }
  }

  @Watch("currentPage")
  onCurrentPageUpdated(): void {
    this.updateDisplayOcojoImages();
    this.selectedItemIndex = this.selectedOcojoImageSource
      ? this.displayOcojoImages.indexOf(this.selectedOcojoImageSource)
      : null;
  }

  updateDisplayOcojoImages(): void {
    this.displayOcojoImages = !!this.foundOcojoImages
      ? this.foundOcojoImages.slice(this.imageCountPerPage * (this.currentPage - 1), this.imageCountPerPage * this.currentPage)
      : [];
  }
}
